import { Component, OnInit } from '@angular/core';
import {UserService} from "../../services/user.service";
import {User} from "../../models/user";
import {ActivatedRoute, Router} from "@angular/router";
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: [
    './register.component.css',
    './css/style.css',
    './font-awesome/css/font-awesome.min.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css'
  ],
  providers: [UserService]
})
export class RegisterComponent implements OnInit {
  public user : User;
  public message;
  public disabled = false;
  actual = environment.actual;
  private messageEnt = environment.entidad[this.actual].messageRegister;
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _userService: UserService
  ) {
    this.user = new User(1,  '',  '',  '',  '',  '',  '', 0, 0);
  }

  ngOnInit() {
  }
  onSubmit(){
    this.message = 'Cargando, Por favor espere...';
    this._userService.httpPost('register', this.user).subscribe(
      response =>{
        let resul = response;
        if(resul.status == 'success'){
          alert(resul.message)
          if(this.messageEnt != ''){
            this.message = this.messageEnt;
          }else{
            this.message = resul.message;
          }
          this.disabled = true;
        }else{
          this.message = resul.message;
          this.disabled = true;
        }
      },
      error =>{
        console.log(<any>error);
      }
    );

  }

}
